import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { dict } from '../i18n';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('iacc_lang') || 'en';
    }
    return 'en';
  });

  useEffect(() => {
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.body.classList.toggle('font-arabic', lang === 'ar');
    document.body.classList.toggle('font-serif-en', lang === 'en');
    localStorage.setItem('iacc_lang', lang);
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === 'en' ? 'ar' : 'en')), []);

  const t = useCallback((path) => {
    const keys = path.split('.');
    let val = dict[lang];
    for (const k of keys) {
      if (val && typeof val === 'object' && k in val) val = val[k];
      else return path;
    }
    return val;
  }, [lang]);

  const pick = useCallback((obj) => {
    if (!obj) return '';
    if (typeof obj === 'string') return obj;
    return obj[lang] || obj.en || '';
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, pick, dir: lang === 'ar' ? 'rtl' : 'ltr' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
